module.exports = {
  siteTitle: 'Doug Macklin',
  siteTitleAlt: 'Doug Macklin',
  siteLogo: '',
  siteDescription: 'Full Stack Web Developer',
  siteUrl: 'https://dougmacklin.com',
  userTwitter: '@dougmacklin',
  siteFBAppID: null,
  googleAnalyticsID: 'UA-38112456-2',
};



// WEBPACK FOOTER //
// ./data/config.js